import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";

interface IProps {
  title: string;
  description: string;
  imageUrl: string;
}

const SmallFeatureCard: React.FC<IProps> = ({
  title,
  description,
  imageUrl,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        border: "none",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: { xs: 2, md: 4 },
      }}
    >
      {/* Image */}
      < Box
        display="flex"
        justifyContent="center"
        sx={{
          width: "auto",
          height: { xs: 257, sm: 326 },
          boxSizing: "border-box",
          bgcolor: "background.default",
          overflow: "hidden",
          borderRadius: "20px",
          paddingY: { xs: 3, md: 4 },
          paddingX: { xs: 1, md: 3 },
        }}
      >
        <CardMedia
          component="img"
          image={imageUrl}
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box >

      {/* Description */}
      < CardContent sx={{ padding: 0 }}>
        <Typography
          variant="h4"
          component="h3"
          color="text.primary"
          mb={{ xs: 1, md: 2 }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={{ sm: 16, md: 18 }}
        >
          {description}
        </Typography>
      </CardContent >
    </Card >
  );
};

export default SmallFeatureCard;
